import Section from '@components/atoms/Section';
import Spacing from '@components/atoms/Spacing';
import { Heading1, Paragraph } from '@components/atoms/Typography';
import BreadCrumbs from '@components/molecules/BreadCrumbs';
import GridLinkList from '@components/molecules/list/GridLinkList';
import PageContainer from '@components/molecules/PageContainer';
import BREAKPOINTS from '@lib/constants/breakpoints';
import ROUTES from '@lib/constants/routes';
import stats from '@lib/data/stats';
import { GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';

interface Props {
  brands: string[];
}

const Header = styled(Section)`
  padding-top: 120px;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    padding-top: 50px;
  }
`;

const Stats = ({ brands }: Props) => {
  const router = useRouter();

  if (router.isFallback) return <PageContainer loading />;

  const links = [
    {
      label: 'Luna',
      href: '/',
    },
    {
      label: 'Ficha técnica',
      href: `${ROUTES.stats.home}`,
    },
    {
      label: 'Motos',
      href: `${ROUTES.stats.type({ type: 'motos' })}`,
    },
  ];
  return (
    <PageContainer
      title="Ficha técnica Motos por Marca"
      metaDescription="Ficha ténica de qualquer moto vendida no Brasil, contendo Informações como potência, economia e muito mais. Tudo em um lugar só."
    >
      <Header>
        <Heading1>Fichas técnicas das Marcas de Moto</Heading1>
        <Spacing top={2}>
          <Paragraph>
            Escolha a marca para ver as fichas técnicas disponíveis
          </Paragraph>
        </Spacing>
      </Header>
      <Section>
        <GridLinkList
          links={brands.map((brand) => ({
            label: brand,
            path: ROUTES.stats.brand({ brand, type: 'motos' }),
          }))}
        />
      </Section>
      <Section style={{ paddingTop: 0 }}>
        <BreadCrumbs links={links} />
      </Section>
    </PageContainer>
  );
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const brands = await stats.getBrands('motorcycle');

  return {
    props: {
      brands,
    },
  };
};

export default Stats;
